/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx';
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../utils/helpers';
import ResizableDataTable from '../../Tables/ResizableTable/components/ResizableReactTable';

const MonthEndInventoryTable = ({ data, tableHeaderData }) => {
    const excelData = data?.length && data.map((item) => {
         const updated = { ...item };
         const { quantity } = updated
         updated.quantity = setCurrencyFormat(Number(quantity).toFixed(0), false);       
         return updated
    });

    const exportToExcel = () => {
        if (!excelData || !excelData.length) return;
        
        // Create worksheet from data
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        
        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Month End Inventory");
        
        // Save file
        XLSX.writeFile(workbook, "Month End Inventory.xlsx");
    };

    return (
        <Row style={{ position: 'relative' }}>
            <div className="ExcelTable" id='dvTable'>
                <Button 
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={exportToExcel}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={data} />
        </Row>
    )
}

MonthEndInventoryTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
};

export default MonthEndInventoryTable;